import React from 'react';
import { connect } from 'react-redux';
import { IconSecurity } from '../../../base/icons/svg';
import { translate } from '../../../base/i18n/functions';
import Label from '../../../base/label/components/web/Label';
import { COLORS } from '../../../base/label/constants';
import Tooltip from '../../../base/tooltip/components/Tooltip';
import { isLocalParticipantModerator } from '../../../base/participants/functions';
const LockMeetingLabel = ({ _locked, t }) => {
    if (!_locked) {
        return null;
    }
    const content = t('lockMeetingLabel');
    return (React.createElement(Tooltip, { content: content, position: 'bottom' },
        React.createElement(Label, { color: COLORS.gray, icon: IconSecurity, className: 'lockMeetingLabel' })));
};
/**
 * Maps (parts of) the redux state to the associated props of this {@code Component}.
 *
 * @param {Object} state - The redux state.
 * @private
 * @returns {IProps}
 */
export function _mapStateToProps(state) {
    const { locked } = state['features/base/conference'];
    const { lobbyEnabled } = state['features/lobby'];
    const isLocalModerator = isLocalParticipantModerator(state);
    return {
        _locked: Boolean((locked || lobbyEnabled) && isLocalModerator)
    };
}
export default translate(connect(_mapStateToProps)(LockMeetingLabel));
